import { useEffect } from "react";
import posthog from "posthog-js";
import { auth } from "@/data/config/firebase-config";

interface UseFirebaseAuthProps {
  onAuthStateChanged: (user: any | null) => void;
  onAuthError?: (error: any) => void;
}

export const useFirebaseAuth = ({
  onAuthStateChanged,
  onAuthError,
}: UseFirebaseAuthProps) => {
  useEffect(() => {
    if (!auth) return;
    const unsubscribe = auth?.onAuthStateChanged(
      (user) => {
        try {
          posthog.identify(user?.uid, user || undefined);
          onAuthStateChanged(user);
        } catch (error) {
          console.error("Firebase auth state change error:", error);
          if (onAuthError) {
            onAuthError(error);
          }
        }
      },
      (error) => {
        console.error("Firebase authentication error:", error);
        if (onAuthError) {
          onAuthError(error);
        }
      }
    );

    return () => unsubscribe();
  }, [onAuthStateChanged, onAuthError]);
};
